import React, { FC, useEffect, useRef, useState } from 'react';
import { useQueryClient } from '@tanstack/react-query';
import MainBox from 'src/components/molecules/contentLayout/MainBox';
import TitleContent from 'src/components/molecules/contentLayout/TitleContent';
import CreditcardData from './CreditcardData';
import AdminAddDoc from './AdminAddDoc';
import DefaultButton from 'src/components/atoms/buttons/DefaultButton';
import TobeInfo from '../TobeInfo';
import { errorModalViewStore } from 'src/store/modal';
import { submitDocDataStore } from 'src/store/submitDoc';
import { submitDocListDataFn } from 'src/fetch/stepD';
import { submitDocDescType } from 'src/static/typeCode';
import { getMemberInfo } from 'src/utils/common';
import '../style.scss';
import './style.scss';

interface Props {
  num: number;
}

const StepD: FC<Props> = ({ num }) => {
  const queryClient = useQueryClient();
  const userInfoData: any = getMemberInfo();
  const errorModalState = errorModalViewStore((state: any) => state.set);
  const submitDocState = submitDocDataStore((state: any) => state.bind);
  const submitDocList: any[] = submitDocDataStore((state: any) => state.result.data) || [];

  const taxData = [
    {
      idx: 0,
      name: '고길동',
      docType: '신용카드 등 사용금액 확인서',
    },
  ];

  useEffect(() => {
    submitDocListDataFn(errorModalState, userInfoData, submitDocState, queryClient);
  }, []);

  const confirmEvt = () => {
    console.log('CONFIRM!');
  };
  const clickEvt = (e: any) => {
    console.log('CLICK!');
  };

  const middleContent = () => {
    return (
      <div className="_temp_content_layout">
        <div className="_info_step">
          <section className="_section_layout">
            <div className="_top_stepd_desc_div">
              <div className="_desc">
                귀하가 입력한 내용에 맞추어 연말정산 신고시 제출해야하는 서류 목록입니다.
              </div>
              {/* <div className="_btn">
                <DefaultButton
                  text="제출 서류 표지 다운로드"
                  clickEvent={e => clickEvt(e)}
                  icon="ri-download-2-line"
                  iconStyleDef={{ fontSize: '14px', paddingTop: '0px' }}
                  type="type1"
                  styleDef={{ height: '30px', fontSize: '12px', width: '170px', color: '#555' }}
                />
              </div> */}
            </div>
          </section>
          <section className="_section_layout">
            <TitleContent
              label="관리자 요청 서류"
              desc="관리자가 요청한 서류입니다."
              vtype="t1"
              content={<AdminAddDoc data={taxData} />}
            />
          </section>
          <div className="_doc_list">
            {submitDocList.map((group: any) => (
              <section className="_section_layout" key={group.uppr_cat_cd}>
                <TitleContent
                  label={group.uppr_cat_nm}
                  desc={submitDocDescType(group.uppr_cat_cd)}
                  vtype="t1"
                  content={<CreditcardData data={group.list} />}
                />
              </section>
            ))}
          </div>
        </div>
      </div>
    );
  };
  return (
    <div className="_step_layout">
      <MainBox
        label="제출서류"
        content={middleContent()}
        num={num}
        icon="ri-folder-open-line"
        desc=<div>
          증빙서류 제출 대상 여부를 확인한 후 누락 없이 제출해 주시기 바랍니다. <br />
          제출서류가 확인되지 않는 항목은 공제 대상에서 제외될 수 있습니다.
        </div>
        confitmEvent={confirmEvt}
      />
    </div>
  );
};

export default StepD;
